import { graphqlRequest } from "../graphqlClient";
import type {
  Forecast12MonthTransactionViewConnection,
  Forecast12MonthTransactionViewFilterInput,
} from "../models/forecast12MonthTransactionView";

export interface Forecast12MonthTransactionViewSortInput {
  field: string;
  order: "Ascending" | "Descending";
}

interface Forecast12MonthTransactionViewListResponse {
  transactions: {
    forecast12MonthTransactionViewList: Forecast12MonthTransactionViewConnection;
  };
}

export async function getForecast12MonthTransactionsGraphql(
  filter?: Forecast12MonthTransactionViewFilterInput,
  first?: number,
  after?: string,
  sort?: Forecast12MonthTransactionViewSortInput[],
): Promise<Forecast12MonthTransactionViewConnection> {
  const query = `
    query Forecast12MonthTransactionViewList($filter: Forecast12MonthTransactionViewFilterInput, $first: Int, $after: String, $sort: [Forecast12MonthTransactionViewSortSortByInput!]) {
      transactions {
        forecast12MonthTransactionViewList(filter: $filter, first: $first, after: $after, sort: $sort) {
          edges {
            cursor
            node {
              id
              forecastDate
              monthKey
              dueDate
              counterpartyName
              description
              category
              direction
              type
              grossAmount
              outstandingAmount
              layer
              status
              reference
              sourceId
              dataSourceName
            }
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
        }
      }
    }
  `;
  const data = await graphqlRequest<Forecast12MonthTransactionViewListResponse>(
    query,
    {
      filter,
      first,
      after,
      sort,
    },
  );
  return data.transactions.forecast12MonthTransactionViewList;
}

interface Forecast12MonthTransactionViewCountResponse {
  transactions: {
    forecast12MonthTransactionViewCount: number;
  };
}

export async function getForecast12MonthTransactionsCount(
  filter?: Forecast12MonthTransactionViewFilterInput,
): Promise<number> {
  const query = `
    query Forecast12MonthTransactionViewCount($filter: Forecast12MonthTransactionViewFilterInput) {
      transactions {
        forecast12MonthTransactionViewCount(filter: $filter)
      }
    }
  `;
  const data =
    await graphqlRequest<Forecast12MonthTransactionViewCountResponse>(query, {
      filter,
    });
  return data.transactions.forecast12MonthTransactionViewCount;
}

interface Forecast12MonthTransactionViewDistinctValuesResponse {
  transactions: {
    forecast12MonthTransactionViewDistinctValues: string[];
  };
}

export async function getForecast12MonthTransactionDistinctValues(
  field: string,
): Promise<string[]> {
  const query = `
    query Forecast12MonthTransactionViewDistinctValues($field: String!) {
      transactions {
        forecast12MonthTransactionViewDistinctValues(field: $field)
      }
    }
  `;
  const data =
    await graphqlRequest<Forecast12MonthTransactionViewDistinctValuesResponse>(
      query,
      {
        field,
      },
    );
  return data.transactions.forecast12MonthTransactionViewDistinctValues;
}
